// T26: Keep the page position stable when a variant image label activates its hidden radio input.
document.addEventListener('click', (event) => {
  const label = event.target.closest(
    '.cc-main-product variant-picker .option-selector__btns .opt-label--image[for]'
  );
  if (!label) return;

  const input = document.getElementById(label.htmlFor);
  if (!input?.matches('.opt-btn')) return;

  event.preventDefault();
  input.focus({ preventScroll: true });
  if (!input.checked) input.click();
});
